/**
 * block.js
 *
 * Handles Swiper JS for the Quote Slider
 */

class QuoteSlider {
    constructor() {
        this.elements = null;
        this.grabElements();

        if (this.elements.slider.length && this.elements.slides.length > 1) {
            this.initSlider();
        }
    }

    grabElements() {
        this.elements = {
            slider: jQuery('.quote-slider__slides'),
            slides: jQuery('.quote-slider__slide')
        };
    }

    initSlider() {
        const swiperEl = this.elements.slider[0];

        const params = {
            // array with CSS styles for navigation and pagination
            pagination: {
                clickable: true
            },
            navigation: false,
            injectStyles: [
                `
                .swiper {
                    overflow: visible;
                }
                
                .swiper-wrapper {
                    align-items: center;

                    @media (max-width: 766px) {
                        padding-bottom: 28px;
                    }
                }

                .swiper-pagination-bullets.swiper-pagination-horizontal {
                    bottom: 0;
                }
                
                .swiper-pagination-bullet {
                    transition: opacity 0.2s ease;
                    margin: 0 4px;
                    width: 3px;
                    height: 3px;
                    background: #fff;
                }

                .swiper-pagination-bullet-active {
                    background: #fff;
                }
                `
            ],
            breakpoints: {
                // when window width is >= 767px
                767: {
                    pagination: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }
        };

        Object.assign(swiperEl, params);

        swiperEl.initialize();
    }
}

jQuery(document).ready(() => {
    window.quoteSlider = new QuoteSlider();
});
